import React from "react";

export default function AppLoadingOverlay({
  open = false,
  label = "Laden...",
  scope = "global",
  blocking = true,
  spinner = null,
  opacity = 0,
  zIndex,
  className = "",
}) {
  if (!open) {
    return null;
  }

  const classes = [
    "ds-loading-overlay",
    scope === "contained" ? "ds-loading-overlay--contained" : "ds-loading-overlay--global",
    blocking ? "ds-loading-overlay--blocking" : "ds-loading-overlay--passive",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={classes}
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        backgroundColor: `rgba(15, 23, 42, ${opacity})`,
        zIndex: zIndex ?? (scope === "global" ? 1600 : 2),
      }}
    >
      <div className="ds-loading-overlay__panel">
        <div className="ds-loading-overlay__spinner" aria-hidden="true">
          {spinner || (
            <span className="ds-loading-overlay__spinner-dots">
              <span className="ds-loading-overlay__spinner-dot" />
              <span className="ds-loading-overlay__spinner-dot" />
              <span className="ds-loading-overlay__spinner-dot" />
            </span>
          )}
        </div>
        {label ? <div className="ds-loading-overlay__label">{label}</div> : null}
      </div>
    </div>
  );
}
